<template>
  <ContactForm
    :item="{
      containerFullWidth: true,
      watchRef: this.item.product.manufacturer_sku,
      subjectListType: 'contact',
      defaultSubject: '10'
    }"
  >
    <ProductMiniPreview :item="this.item" :picture="this.picture" />
  </ContactForm>
</template>

<script>
import { ReadyHook } from 'vue-asyncready'
import ContactForm from './ContactForm.vue'
import ProductMiniPreview from './utils/ProductMiniPreview.vue'

export default {
  name: 'PdpEmailform',
  props: ['item', 'picture'],
  mixins: [ReadyHook],
  components: {
    ContactForm,
    ProductMiniPreview
  },
}
</script>

<style lang="scss" scoped>
@import '~theme/css/core';
</style>
